"use client";
import { UserCircle, Pencil, ChevronDown, Info } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
// import {  InputHTMLAttributes } from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { useLocation } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { Label } from "@/components/ui/label";

import TextField from "@mui/material/TextField";
import { addCompanyDetails, getValidProfileUrl, getWorkCategory } from "../services/company-details";
import { useNavigate } from "react-router-dom";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import {
  getMasterData,
  MasterData,
  MasterDataParam,
} from "@/features/crm/addLeads/add-leads";
// import { objectToFormData } from "./company-createDetails";
import toastService from "@/services/toastService";
import { BuilderProject } from "../ui/add-new-project";
import useDebounce from "@/hooks/useDebounce";
import PhoneInput from "../../../questionnaire/ui/input-types/PhoneInput";

type City = {
  id: number;
  name: string;
  region_id: [number, string];
  state_id: [number, string];
  county_id: [number, string] | false;
};

type CompanyDetails = {
  companyName: string;
  email: string;
  phoneNumber: string;
  category: string[];
  address: string;
  country: string;
  county?: string;
  province: string;
  region: string;
  city: string;
  citiesServed: string[];
  postalCode: string;
  companyDescription: string;
  website: string;
  facebookUrl: string;
  instagramUrl: string;
  youTubeUrl: string;
  linkedInUrl: string;
  xUrl: string;
  profileImage: File | null;
  profileUrl?: string;
  contactName: string,
  seo: string;
  companyId?: number;
  _id?: string;
  __v?: number
  createdAt?: string;
  updatedAt?: string
  profileImageUrl?: string;
  projects?: BuilderProject[]

};

export default function CompanyProfileForm() {
  const location = useLocation();
  const companyDetails = location.state?.companyDetails;
  const navigate = useNavigate();

  console.log(companyDetails, "line 24");

  const [masterData, setMasterData] = useState<Partial<MasterData>>();
  const [citiesServed, setCitiesServed] = useState<City[]>([]);
  const [selectedCitiesServed, setselectedCitiesServed] = useState<
    string[]
  >([]);
  const [validProfile, setValidProfile] = useState<boolean | null>(null);
  const [formData, setFormData] = useState<CompanyDetails>({
    companyName: "",
    contactName: "",
    email: "",
    phoneNumber: "",
    category: [],
    address: "",
    country: "",
    county: "",
    province: "",
    region: "",
    city: "",
    citiesServed: [],
    postalCode: "",
    companyDescription: "",
    website: "",
    facebookUrl: "",
    instagramUrl: "",
    youTubeUrl: "",
    linkedInUrl: "",
    xUrl: "",
    profileImage: null,
    profileUrl: "",
    seo: "",
    companyId: 0,
    _id: "",
    __v: 0,
    createdAt: "",
    updatedAt: "",
    profileImageUrl: "",
    projects: []
  });

  const [workCategory, setWorkCategory] = useState<[number, string][]>([]);
  const [selectedregionName, setSelectedregionName] = useState<string>("");
  const [selectedcountyName, setSelectedcountyName] = useState<string>("");
  const workCategoryNames = workCategory.map(([_, name]) => name);
  const [selectedcityName, setSelectedcityName] = useState<string>("");
  const citiesServedNames = citiesServed.map((city) => city?.name);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm);
  const [selectedWorkCategories, setSelectedWorkCategories] = useState<
    string[]
  >([]);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [cityOptions, setCityOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
      region_id: [number, string];
      county_id: [number, string];
    }[]
  >([]);

  console.log(isPhoneValid)

  useEffect(() => {
    const validateProfileUrl = async () => {
      if (debouncedSearchTerm.trim() !== "") {
        console.log(debouncedSearchTerm, "line 1000")
        const response = await getValidProfileUrl(debouncedSearchTerm,companyDetails.compa);
        console.log(response?.data?.isValid, "line 207")

        setValidProfile(response?.data?.isValid);
      }
    };

    validateProfileUrl();
  }, [debouncedSearchTerm]);
  console.log(isPhoneValid)

  const [selectedCountryName, setSelectedCountryName] = useState<string>("");
  const [provinceOptions, setProvinceOptions] = useState<
    {
      country_id: [number, string];
      id: number;
      name: string;
    }[]
  >();
  const [regionOptions, setRegionOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
    }[]
  >([]);
  const [selectedProvinceName, setSelectedProvinceName] = useState<string>("");
  const [countyOptions, setCountyOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
      region_id: [number, string];
    }[]
  >([]);


  const isFormValid =
    formData.companyName.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.contactName.trim() !== "" &&
    //   Array.isArray(formData.category) && formData.category.length > 0
    // &&
    selectedWorkCategories.length > 0 &&
    formData.category.length > 0 &&
    formData.address?.trim() !== "" &&
    formData.province?.trim() !== "" &&
    formData.profileUrl?.trim() !== "" &&
    formData.country?.trim() !== "";



  console.log(isFormValid, "line 201")
  console.log(formData.category.length, selectedWorkCategories, "line 206")

  console.log(selectedCountryName, selectedcityName, selectedcountyName, selectedProvinceName, selectedregionName, "line 124");

  useEffect(() => {
    const prefillForm = async () => {
      if (companyDetails) {
        if (companyDetails.profileImageUrl) {
          setImagePreview(companyDetails.profileImageUrl); // ← this line is crucial
        }
        if (companyDetails?.seo) {
          formData.profileUrl = companyDetails?.seo
        }

        const updatedFormData = { ...companyDetails };
        console.log(updatedFormData, "line 187")
        setSelectedWorkCategories(companyDetails.category || []);
        setselectedCitiesServed(companyDetails.citiesServed || [])
        console.log(companyDetails.province, "line 135");


        // Map country name → ID
        if (masterData?.countries?.length) {
          const countryObj = masterData.countries.find(
            (c) => c.name === companyDetails.country
          );
          console.log(countryObj, "line 146");
          console.log(countryObj, "line 146");

          if (countryObj) {
            const countryId = String(countryObj.id);
            updatedFormData.country = countryId;
            setSelectedCountryName(countryObj.name);

            //  Step 1: Load provinces
            const provinces = await getProvinceOptions(countryId);
            console.log(provinces, "line 151");

            //  Step 2: Set province after options are loaded
            if (provinces?.length) {
              const provinceObj = provinces.find(
                (p: any) => p.name === companyDetails.province
              );

              console.log(provinceObj, "line 153");
              if (provinceObj) {
                updatedFormData.province = String(provinceObj.id);
                setSelectedProvinceName(provinceObj.name);
              }
              const regions = await getRegionsForProvince(provinceObj.id);
              console.log(regions, "line 184");
              const regionObj = regions.find(
                (r: any) => r.name === companyDetails.region
              );
              if (regionObj) {
                updatedFormData.region = String(regionObj.id);
                setSelectedregionName(regionObj.name);
              }
              if (selectedCountryName === 'United States' || companyDetails.country === 'United States' && companyDetails.county !="" ) {
                const counties = await getCountiesForProvinceAndRegion(provinceObj.id, regionObj.id);
                const countyObj = counties.find(
                  (c: any) => c.name === companyDetails.county
                );
                if (countyObj) {
                  updatedFormData.county = String(countyObj.id);
                  setSelectedcountyName(countyObj.name);
                }
              }

              const cities = await getCitiesOptionsFromProvice(provinceObj?.id);
              console.log(cities, "line 184");
              const cityObj = cities.find(
                (city: any) => city.name === companyDetails.city
              );
              if (cityObj) {
                updatedFormData.city = String(cityObj.id);
                setSelectedcityName(cityObj.name);
              }
            }
          }
          setTimeout(() => {
            setFormData(updatedFormData);

          }, 500);
        }
      }
    };

    if (companyDetails && masterData) {
      prefillForm();
      console.log("prefill form called!", companyDetails, masterData);
    }
  }, [companyDetails, masterData]);

  useEffect(() => {
    const callToMaster = async () => {
      const params: Partial<MasterDataParam> = {
        countries: true,
        provinces: true,
        projectClasses: true,
        projectTypes: true,
        projectStatuses: true,
        regions: true,
        counties: true,
        cities: true,
      };
      const data = await getMasterData(params);
      console.log("master data", data);
      setMasterData(data);
    };


    callToMaster();
    fetchWorkCategory();

  }, []);

  const fetchWorkCategory = useCallback(async () => {

    try {
      const response = await getWorkCategory();
      console.log(response, "line 120");
      console.log(response?.data?.workCategory, "line 122");

      // Extract IDs & Names

      setWorkCategory(response?.data?.workCategory);

    } catch (err) {
      console.error("Error fetching team members:", err);

    }
  }, []);
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        profileImage: file,
      }));

      //  Create base64 string for image preview
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          setImagePreview(reader.result); // base64 for preview only
        }
      };
      reader.readAsDataURL(file);
      formData.profileImage = file
    }
  };


  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value, // Allow empty string
    }));
    // if (id === "profileUrl") {
    //   setSearchTerm(value); // update searchTerm for debounced API call
    // }
    if (id === "profileUrl") {
      setSearchTerm(value); // update searchTerm for debounced API call
    
      if (value.trim() === "") {
        setValidProfile(null); // Reset validity state when empty
      }
    }
  };



  const getProvinceOptions = useCallback(async (country_id: string) => {


    const d = await getMasterData({
      countryId: Number(country_id),
      provinces: true,
    });

    if (d && d.provinces) {
      setProvinceOptions(d.provinces);

      return d.provinces; //  return the provinces
    } else {
      setProvinceOptions([]);
      return []; //  return empty array
    }
  }, []);

  const getRegionsForProvince = useCallback(
    async (provinceId: string) => {
      if (provinceId) {
        try {
          const data = await getMasterData({
            provinceId: Number(provinceId),
            regions: true,
            cities: true,
          });

          // Check if the response contains regions and update the state
          if (data?.regions || data?.cities) {
            setRegionOptions(data.regions);
            setCityOptions(data.cities);
            setCitiesServed(data.cities)
            return data.regions;
          } else {
            setRegionOptions([]); // Set empty array if no regions are returned
          }
        } catch (error) {
          console.error("Error fetching regions:", error);
          setRegionOptions([]); // Set empty array in case of error
        }
      } else {
        setRegionOptions([]); // Clear regions if no provinceId
      }
    },
    [] // No dependencies needed, can be added if masterData changes
  );

  const getCountiesForProvinceAndRegion = useCallback(
    async (province_id: string, region_id: string) => {
      if (province_id && region_id) {
        const data = await getMasterData({
          provinceId: Number(province_id),
          regionId: Number(region_id),
          counties: true,
          cities: true,
        });

        if (data?.counties || data?.cities) {
          setCountyOptions(data.counties);
          setCityOptions(data.cities);
          return data.counties

        } else {
          setCountyOptions([]);
        }
      } else {
        setCountyOptions([]);
      }
    },
    []
  );

  const getCitiesOptions = useCallback(async (county_id: string) => {
    const d = await getMasterData({
      countyId: Number(county_id),
      cities: true,
    });
    if (d && d.cities) {
      setCityOptions(d.cities);
      return d.cities;

    } else {
      setCityOptions([]);

    }
  }, []);
  const getCitiesOptionsFromProvice = useCallback(async (province_id: string) => {
    const d = await getMasterData({
      provinceId: Number(province_id),
      cities: true,
    });
    if (d && d.cities) {
      setCityOptions(d.cities);
      return d.cities;

    }
    else {
      setCityOptions([]);

    }
  }, []);

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const countryObj = masterData?.countries?.find(
      (c) => String(c.id) === formData.country
    );

    const provinceObj = provinceOptions?.find(
      (p) => String(p.id) === formData.province
    );

    const regionObj = regionOptions?.find(
      (r) => String(r.id) === formData.region
    );

    let countyObj: { name: string } | undefined;
    if (countryObj?.name === 'United States') {
      countyObj = countyOptions?.find(
        (c) => String(c.id) === formData.county
      );
    }

    console.log(formData.phoneNumber, "line 490")

    const cityObj = cityOptions?.find(
      (city) => String(city.id) === formData.city
    );
    formData.citiesServed = selectedCitiesServed || companyDetails.citiesServed
    formData.category = selectedWorkCategories || companyDetails.category
    formData.seo = formData?.profileUrl || companyDetails.seo

    const submissionData = {
      ...formData,
      country: countryObj?.name || "", // fallback to ID if not found
      province: provinceObj?.name || "",
      region: regionObj?.name || "",
      county: countyObj?.name || "",
      city: cityObj?.name || "",
    };
    if (submissionData.country !== "United States") {
      delete (submissionData as { county?: string }).county;
    }



    console.log(formData, "line 511")
    delete submissionData.companyId;
    delete submissionData._id;
    delete submissionData.__v;
    delete submissionData.createdAt;
    delete submissionData.updatedAt;
    delete submissionData.profileImageUrl;
    delete submissionData.projects;
    delete submissionData.profileUrl;



    // console.log("line 484", submissionData);
    const newformData = objectToFormData(submissionData) as FormData;
    for (let [key, value] of newformData.entries()) {
      console.log(`${key}: ${value}`, "line 487");
    }

    const response = await addCompanyDetails(newformData);
    console.log(response.data, "line 72");
    if (response.statusCode === 200) {
      toastService.success("Company Profile Updated Successfully")
      navigate("/profile/company-profile");
    }



  };

  return (
    <div className="mx-auto p-4 md:p-6 bg-white">
      <div className="mb-8 flex justify-start">
        <div className="relative">
          <div className="mb-5">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="secondary"
                    className="flex items-center gap-x-1"
                    size="icon"
                    onClick={() => history.back()}
                  >
                    <ChevronLeft />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Go Back</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

          <div className="h-20 w-20 bg-gray-100 rounded-full flex items-center justify-center overflow-hidden">
            {/* Display uploaded image or default icon */}
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Profile"
                className="h-20 w-20 object-cover"
              />
            ) : (
              <UserCircle className="h-12 w-12 text-gray-500" />
            )}
          </div>
          <div className="absolute h-7 w-7 bottom-0 right-0 rounded-full border-2 border-white bg-green-500 flex items-center justify-center">
            <input
              type="file"
              // accept="image/*"
              accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
              onChange={handleImageChange}
              className="absolute inset-0 opacity-0"
            />
            <Pencil className="h-3.5 w-3.5 text-white" />
          </div>
        </div>
      </div>

      <form className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="space-y-2">
            <label
              htmlFor="company-name"
              className="block text-sm font-medium text-gray-700"
            >
              Company Name *
            </label>
            <input
              type="text"
              id="companyName"
              placeholder="Enter Company Name"
              value={formData.companyName}
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="contact-name"
              className="block text-sm font-medium text-gray-700"
            >
              Contact Name *
            </label>
            <input
              type="text"
              id="contactName"
              placeholder="Enter Contact Name"
              value={formData.contactName}
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email *
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
          </div>

          {/* <div className="space-y-2">
            <label
              htmlFor="phoneNumber"
              className="block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            <input
              type="tel"
              id="phoneNumber"
              placeholder="Enter Phone Number"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
            />
          </div> */}


          {/* <PhoneInput
                      value={formData.phoneNumber}
                      country={formData.country}
                        onSubmit={(ans: string | string[]) => {
                          const phoneNumber = Array.isArray(ans) ? ans[0] : ans;
                          setFormData((prev) => ({ ...prev, phoneNumber }));
                        }}
                        onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
                        placeholder="Enter Phone"
                      /> */}

          <div className="space-y-2">
            <Label className="block text-sm font-medium mb-2 text-[#616161]">
              Work Category *
            </Label>
            <Autocomplete
              id="auto-partners"
              className="z-20 w-full mb-8"
              options={workCategoryNames} // Only name strings
              multiple
              disablePortal
              size="small"
              selectOnFocus
              value={selectedWorkCategories}
              onChange={(_, newValue) => {
                setSelectedWorkCategories(newValue); // Save names only
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Work Category"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": { fontSize: "14px" },
                    "& .MuiChip-root": { fontSize: "14px", height: "24px" },
                    "& .MuiChip-label": { padding: "0 4px" },
                    "& .MuiInputBase-input::placeholder": { fontSize: "14px" },
                  }}
                />
              )}
            />


          </div>

          <div className="space-y-2">
            <label
              htmlFor="address"
              className="block text-sm font-medium text-gray-700"
            >
              Address *
            </label>
            <input
              type="text"
              id="address"
              value={formData.address}
              placeholder="Enter Address"
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
          </div>


          <div className="space-y-2">
            <label
              htmlFor="country"
              className="block text-sm font-medium text-gray-700"
            >
              Country *
            </label>

            <div className="relative">
              <Select
                value={formData.country || ""}
                onValueChange={(selectedValue) => {
                  // selectedValue = companyDetails.country
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      country: "",
                      province: "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    setSelectedCountryName(""); // Clear the selected country name
                    getProvinceOptions("");
                    setCitiesServed([]);
                    setselectedCitiesServed([])
                  } else {
                    console.log("country changed", selectedValue);

                    const selectedCountry = masterData?.countries?.find(
                      (c) => String(c.id) === selectedValue
                    );
                    console.log(selectedCountry, "line 488");

                    setSelectedCountryName(selectedCountry?.name ?? "");

                    setFormData((prev) => ({
                      ...prev,
                      country: selectedValue,
                      province: "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    if (selectedValue) {
                      getProvinceOptions(selectedValue);
                      setCitiesServed([]);
                      setselectedCitiesServed([])
                    }
                  }
                }}
              // value={formData.country || ""}
              >
                <SelectTrigger className="w-full px-3 border border-gray-300 rounded-md  h-[40px]">
                  <SelectValue placeholder="Select Country" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {masterData &&
                    masterData?.countries &&
                    masterData?.countries?.length > 0 ? (
                    masterData.countries.map((country) => (
                      <SelectItem key={country.id} value={String(country.id)}>
                        {country.display_name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No data available
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label
              htmlFor="province"
              className="block text-sm font-medium text-gray-700"
            >
              Province/State *
            </label>
            <div className="relative">
              <Select
                value={formData.province || ""}
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      province: "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    getRegionsForProvince("");
                    setCitiesServed([]);
                    setselectedCitiesServed([])
                  } else {
                    const selectedProvince = provinceOptions?.find(
                      (prov) => String(prov.id) === selectedValue
                    );
                    setFormData((prev) => ({
                      ...prev,
                      province: selectedValue, // store ID
                      region: "",
                      county: "",
                      city: "",
                    }));
                    if (selectedValue) {
                      setSelectedProvinceName(selectedProvince?.name || "");

                      getRegionsForProvince(selectedValue);
                      setCitiesServed([]);
                      setselectedCitiesServed([])
                    }
                  }
                }}
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    if (!formData.country) {
                      e.preventDefault();
                    }
                  }}
                  className={`w-full px-3 border border-gray-300 rounded-md  h-[40px] ${!formData.country ? "cursor-not-allowed opacity-50" : ""
                    }`}
                >
                  <SelectValue placeholder="Select State/Province" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {provinceOptions?.map((province) => (
                    <SelectItem key={province.id} value={String(province.id)}>
                      {province.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label
              htmlFor="region"
              className="block text-sm font-medium text-gray-700"
            >
              Region <span className="text-red-500"></span>
            </label>
            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      region: "",
                      // regionName: "",
                      county: "",
                      city: "",
                    }));
                    return;
                  }

                  const selectedRegion = regionOptions.find(
                    (r: any) => r.id.toString() === selectedValue
                  );

                  setFormData((prev) => ({
                    ...prev,
                    region: selectedValue,
                    // regionName: selectedRegion?.name || "",
                    county: "",
                    city: "",
                  }));

                  if (formData.province) {
                    setSelectedregionName(selectedRegion?.name || "");
                    getCountiesForProvinceAndRegion(
                      formData.province,
                      selectedValue
                    );
                  }
                }}
                value={formData.region || ""}
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    if (!formData.country) {
                      e.preventDefault(); // Prevent open if no country is selected
                    }
                  }}
                  className={`w-full px-3 border border-gray-300 rounded-md  h-[40px] ${!formData.country ? "cursor-not-allowed opacity-50" : ""
                    }`}
                >
                  <SelectValue placeholder="Select Region" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {regionOptions && regionOptions.length > 0 ? (
                    regionOptions.map((region) => (
                      <SelectItem key={region.id} value={region.id + ""}>
                        {region.name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No data available
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>
          {selectedCountryName === "United States" && (
            <div className="space-y-2">
              <label
                htmlFor="county"
                className="block text-sm font-medium text-gray-700"
              >
                County <span className="text-red-500"></span>
              </label>
              <div className="relative">
                <Select
                  onValueChange={(selectedValue) => {
                    if (selectedValue === "clear") {
                      setFormData((prev) => ({
                        ...prev,
                        county: "",
                        // countyName: "",
                        city: "",
                      }));
                      getCitiesOptions("");
                    } else {
                      const selectedCounty = countyOptions?.find(
                        (c) => c.id.toString() === selectedValue
                      );
                      setFormData((prev) => ({
                        ...prev,
                        county: selectedValue,
                        // countyName: selectedCounty?.name || "",
                        city: "",
                      }));
                      getCitiesOptions(selectedValue);
                      setSelectedcountyName(selectedCounty?.name || "");
                    }
                  }}
                  value={formData.county || ""}
                  disabled={!formData.region}
                >
                  <SelectTrigger
                    onMouseDown={(e) => {
                      if (!formData.region) e.preventDefault();
                    }}
                    className={`w-full px-3 border border-gray-300 rounded-md  h-[40px] ${!formData.region ? "cursor-not-allowed opacity-50" : ""
                      }`}
                  >
                    <SelectValue placeholder="Select County" />
                  </SelectTrigger>

                  <SelectContent className="max-h-[200px] overflow-y-auto">
                    <SelectItem value="clear" className="text-red-500 italic">
                      Clear selection
                    </SelectItem>

                    {countyOptions && countyOptions.length > 0 ? (
                      countyOptions.map((county) => (
                        <SelectItem
                          key={county.id}
                          value={county.id.toString()}
                        >
                          {county.name}
                        </SelectItem>
                      ))
                    ) : (
                      <SelectItem value="NA" disabled>
                        No data available
                      </SelectItem>
                    )}
                  </SelectContent>
                </Select>

                <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
              </div>
            </div>
          )}

          <div className="space-y-2">
            <label
              htmlFor="city"
              className="block text-sm font-medium text-gray-700"
            >
              City <span className="text-red-500"></span>
            </label>
            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      city: "",
                      // cityName: "",
                    }));
                  } else {
                    const selectedCity = cityOptions.find(
                      (c) => c.id.toString() === selectedValue
                    );
                    setFormData((prev) => ({
                      ...prev,
                      city: selectedValue,
                      // cityName: selectedCity?.name || "",
                    }));
                    setSelectedcityName(selectedCity?.name || "");
                  }
                }}
                value={formData.city || ""}
                disabled={
                  (selectedCountryName === "United States" &&
                    !formData.county) ||
                  (selectedCountryName === "Canada" && !formData.region)
                }
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    const shouldBlock =
                      (selectedCountryName === "United States" &&
                        !formData.county) ||
                      (selectedCountryName === "Canada" && !formData.region);
                    if (shouldBlock) e.preventDefault();
                  }}
                  className={`w-full px-3 border border-gray-300 rounded-md  h-[40px] ${(selectedCountryName === "United States" &&
                    !formData.county) ||
                    (selectedCountryName === "Canada" && !formData.region)
                    ? "cursor-not-allowed opacity-50"
                    : ""
                    }`}
                >
                  <SelectValue placeholder="Select City" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {cityOptions.length > 0 ? (
                    cityOptions.map((city) => (
                      <SelectItem key={city.id} value={city.id.toString()}>
                        {city.name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No cities found
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="block text-sm font-medium mb-2 text-[#616161]">
              Cities Served
            </Label>
            <Autocomplete
              id="auto-partners"
              className="z-20 w-full mb-8"
              options={citiesServedNames}
              multiple
              disablePortal
              size="small"
              selectOnFocus
              value={selectedCitiesServed}
              onChange={(_, newValue) => {
                setselectedCitiesServed(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Cities Served"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": { fontSize: "14px" },
                    "& .MuiChip-root": { fontSize: "14px", height: "24px" },
                    "& .MuiChip-label": { padding: "0 4px" },
                    "& .MuiInputBase-input::placeholder": { fontSize: "14px" },
                  }}
                />
              )}
            />
          </div>

          <div className="space-y-2">
<label htmlFor="profileUrl" className="block text-sm font-medium text-gray-700">
  <div className="inline-flex items-center gap-1">
    <span>Profile URL *</span>
    
    <HoverCard>
      <HoverCardTrigger asChild>
        <button type="button">
          <Info  size={16}/>
          {/* <img src={infoIcon} className="w-4 h-4 " alt="info" /> */}
        </button>
      </HoverCardTrigger>
      <HoverCardContent className="w-64 mt-2 z-50" align="end">
        <p className="text-sm text-gray-700">
          Enter a valid profile URL. This will be used to create your company profile page.
          <br />
          <br />
          Example: <span className="text-blue-500">https://example.com/company-profile</span>
        </p>
      </HoverCardContent>
    </HoverCard>
  </div>
</label>
            <input
              type="text"
              id="profileUrl"
              name="profileUrl"
              placeholder="Enter Profile URL"
              value={formData.profileUrl}
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
            {validProfile === false && (
              <p className="text-red-500 text-xs mt-1">Invalid Profile URL</p>
            )}
            {validProfile === true && (
              <p className="text-green-500 text-xs mt-1">Valid Profile URL</p>
            )}
          </div>



          <div className="space-y-2">
            <label
              htmlFor="postalCode"
              className="block text-sm font-medium text-gray-700"
            >
              Zip/Postal Code
            </label>
            <input
              type="text"
              id="postalCode"
              placeholder="Enter Zip/Postal Code"
              value={formData.postalCode}
              onChange={handleChange}
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700"
            >
              Phone Number
            </label>
            {/* <PhoneInput
              value={formData.phoneNumber}
              country={formData.country}
              onSubmit={(ans: string | string[]) => {
                const phoneNumber = Array.isArray(ans) ? ans[0] : ans;
                setFormData((prev) => ({ ...prev, phoneNumber }));
              }}
              onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
              placeholder="Enter Phone"
              className='p-0'
              inputComponent={(props : InputHTMLAttributes<HTMLInputElement>) => <input {...props} className="w-full px-3 py-2 rounded-md h-[40px] focus:outline-none focus:ring-2" />}
            /> */}
            <PhoneInput
                          value={formData.phoneNumber}
                          country={formData.country}
                          onSubmit={(phoneNumber: string | string[]) => {
                            const num = Array.isArray(phoneNumber) ? phoneNumber[0] : phoneNumber;
                            setFormData(prev => ({ ...prev, phoneNumber: num }));
                          }}
                          onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
                          placeholder="Enter Phone"
                          className="w-full px-3 py-2 rounded-md h-[40px] focus:outline-none focus:ring-2"
                        />
          </div>
        </div>

        {/* <div className="space-y-2">
          <label
            htmlFor="companyDescription"
            className="block text-sm font-medium text-gray-700"
          >
            Company Description
          </label>
          <textarea
            id="companyDescription"
            placeholder="Enter Description"
            value={formData.companyDescription}
            onChange={handleChange}
            rows={5}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
          ></textarea>
        </div> */}
        <div className="space-y-2">
          <label
            htmlFor="description"
            className="block text-sm font-medium text-gray-700"
          >
            Company Description
          </label>
          <textarea
            id="companyDescription"
            placeholder="Enter Description"
            value={formData.companyDescription}
            onChange={(e) => {
              const input = e.target.value;
              if (input.length <= 150) {
                setFormData((prev) => ({
                  ...prev,
                  companyDescription: input,
                }));
              }
            }}
            rows={5}
            maxLength={150}
            className="w-full px-3 border border-gray-300 rounded-md"
          ></textarea>
          <div className="text-right text-sm text-gray-500">
            {formData.companyDescription.length}/150
          </div>
        </div>



        {/* Contact Information */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Contact Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="space-y-2">
              <label
                htmlFor="website"
                className="block text-sm font-medium text-gray-700"
              >
                Website
              </label>
              <input
                type="url"
                id="website"
                placeholder="Enter Website"
                value={formData.website}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="facebookUrl"
                className="block text-sm font-medium text-gray-700"
              >
                Facebook URL
              </label>
              <input
                type="url"
                id="facebookUrl"
                placeholder="Enter Facebook URL"
                value={formData.facebookUrl}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="instagramUrl"
                className="block text-sm font-medium text-gray-700"
              >
                Instagram URL
              </label>
              <input
                type="url"
                id="instagramUrl"
                placeholder="Enter Instagram URL"
                value={formData.instagramUrl}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="youTubeUrl"
                className="block text-sm font-medium text-gray-700"
              >
                YouTube URL
              </label>
              <input
                type="url"
                id="youTubeUrl"
                placeholder="Enter YouTube URL"
                value={formData.youTubeUrl}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="linkedInUrl"
                className="block text-sm font-medium text-gray-700"
              >
                LinkedIn URL
              </label>
              <input
                type="url"
                id="linkedInUrl"
                placeholder="Enter LinkedIn URL"
                value={formData.linkedInUrl}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="xUrl"
                className="block text-sm font-medium text-gray-700"
              >
                X URL
              </label>
              <input
                type="url"
                id="xUrl"
                placeholder="Enter X URL"
                value={formData.xUrl}
                onChange={handleChange}
                className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => navigate("/profile/company-profile")}
            className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={`px-6 py-2 rounded ${isFormValid
                ? "bg-green-500 text-white hover:bg-green-600"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
            disabled={!isFormValid}
          >
            Update Details
          </button>

          {/* <button
            onClick={handleSubmit}
            className="px-6 py-2 rounded bg-green-500 text-white hover:bg-green-600 transition"
          >
            Update Details
          </button> */}

        </div>
      </form>
    </div>
  );
}
// function objectToFormData(data: CompanyDetails): FormData {
//   const form = new FormData();

//   Object.entries(data).forEach(([key, value]) => {
//     if (
//       value !== undefined &&
//       value !== null &&
//       !(typeof value === "string" && value.trim() === "")
//     ) {
//       if (Array.isArray(value)) {
//         value.forEach((item, index) => {
//           if (item !== null && item !== undefined && String(item).trim() !== "") {
//             form.append(`${key}[${index}]`, String(item));
//           }
//         });
//       }
//       else if (value instanceof File) {
//         form.append(key, value); // ✅ correctly attach the file
//       }
//       else {
//         form.set(key, String(value)); // Use append instead of set
//       }
//     }
//   });

//   return form;
// }
export function objectToFormData(data: CompanyDetails): FormData {
  const form = new FormData();
  console.log(data, "line 1369")

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          // ✅ Append empty array as key[]
          form.append(`${key}[]`, '');
        } else {
          value.forEach((item, index) => {
            if (item !== null && item !== undefined) {
              form.append(`${key}[${index}]`, String(item));
            }
          });
        }
      } else if (value instanceof File) {
        form.append(key, value); // ✅ attach file
      } else {
        // ✅ Allow empty strings too
        form.append(key, String(value));
      }
    }
  });

  return form;
}